const SENSITIVE_KEYS = [
  'password',
  'secret',
  'token',
  'apikey',
  'api_key',
  'api-key',
  'authorization',
  'bearer',
  'sfly-apikey',
  'x-xsrf-token',
  'access_token',
  'id_token',
  'refresh_token',
  'x-api-key',
];

const SENSITIVE_REGEX =
  /(password|secret|token|apikey|api_key|api-key|authorization|bearer|sfly-apikey|x-xsrf-token|access_token|id_token|refresh_token|x-api-key)[^=:\s]*[=:\s]+([^\s,]*)/gi;

/**
 * Checks if a key contains any sensitive keyword.
 */
function isSensitiveKey(key) {
  const lowerKey = key.toLowerCase();
  return SENSITIVE_KEYS.some((sensitive) => lowerKey.includes(sensitive));
}

/**
 * Recursively redacts sensitive strings or object values.
 * Preserves key names and replaces sensitive values with `<masked>`.
 */
export function redactSensitiveStrings(input) {
  if (Array.isArray(input)) {
    return input.map((item) => redactSensitiveStrings(item));
  }

  if (input !== null && typeof input === 'object') {
    const redacted = {};
    for (const [key, value] of Object.entries(input)) {
      redacted[key] = isSensitiveKey(key)
        ? '<masked>'
        : redactSensitiveStrings(value);
    }
    return redacted;
  }

  if (typeof input === 'string') {
    return input.replace(SENSITIVE_REGEX, (match, key) => `${key}=<masked>`);
  }

  return input;
}
